module.exports = __webpack_public_path__ + "static/GCE_Device_Strip_update-da3957a07a75ca9526a1d109b75898ba.png";